import { 
        IMAGES_URL, 
        CAROUSEL_IMAGES_NARCAN_URL,
        CAROUSEL_IMAGES_NARCAN_NEW,
        CAROUSEL_IMAGES_WALL_UNIT_NEW,
        CAROUSEL_IMAGES_NARCAN_CASE
     } from './Images';

import config from '../config';


export const PRODUCTS = [
        { 
            "id": "NARCAN",
            "urlId": "narcan",
            "name": "NARCAN® Nasal Spray Emergency Opioid Overdose Treatment",
            "shortName": "NARCAN® Nasal Spray",
            "description": `Designed to rapidly reverse the effects of a life-threatening opioid emergency. Easy to use NARCAN® Nasal Spray is an addition to any emergency first aid kit. Use as directed.`,
            "taxCode": "51010",
            "price": 34.97,
            "shortQtyDescriptor": "bx",
            "thumbnail": IMAGES_URL.NARCAN_LANDING,
            "fullsizeImg": IMAGES_URL.NARCAN_LANDING,
            "link": "/product/narcan",
            "descriptionHtml": `<div>

               
                    <p>
Designed to rapidly reverse the effects of an opioid emergency within minutes.
Easy to use NARCAN® Nasal Spray is an addition to any emergency first aid kit. Use as directed.

                    </p>
                    <p>
                      <h3>Key Features:</h3>
                      <ul>
                          <li>NARCAN® Nasal Spray is easy to use. No nasal swabs or needles</li>
                          <li>Safe to use, even if opioids are not present</li>
                          <li>Original prescription strength</li>
                          <li>Works quickly, reversing an opioid overdose in minutes</li>
                      </ul>
                    </p>
                </div>`,
            "galleryImages": [
              {
                original: CAROUSEL_IMAGES_NARCAN_NEW.CAROUSEL_IMAGES_NARCAN_ONE_NEW,
                thumbnail: CAROUSEL_IMAGES_NARCAN_NEW.CAROUSEL_IMAGES_NARCAN_ONE_NEW
              },
              {
                original: CAROUSEL_IMAGES_NARCAN_NEW.CAROUSEL_IMAGES_NARCAN_TWO_NEW,
                thumbnail: CAROUSEL_IMAGES_NARCAN_NEW.CAROUSEL_IMAGES_NARCAN_TWO_NEW
              },
              {
                original: CAROUSEL_IMAGES_NARCAN_NEW.CAROUSEL_IMAGES_NARCAN_THREE_NEW,
                thumbnail: CAROUSEL_IMAGES_NARCAN_NEW.CAROUSEL_IMAGES_NARCAN_THREE_NEW
              },
              {
                original: CAROUSEL_IMAGES_NARCAN_NEW.CAROUSEL_IMAGES_NARCAN_FOUR_NEW,
                thumbnail: CAROUSEL_IMAGES_NARCAN_NEW.CAROUSEL_IMAGES_NARCAN_FOUR_NEW
              }
          
            ],
            "hasNarcanAddOn": false,
            "isComingSoon": false,
            "hideOnProd": false,
            "isPreorder": false,
            "minQty": 2
        },
        { 
            "id": "NARCAN_CASE",
            "urlId": "narcan-case",
            "name": "NARCAN® NASAL Spray 4 mg, 6-Count Multipack (sold in a case of 12 multipacks)",
            "shortName": "NARCAN® NASAL Spray 4 mg, 6-Count Multipack (sold in a case of 12 multipacks)",
            "description": "Designed to rapidly reverse the effects of a life-threatening opioid emergency. Easy to use NARCAN® Nasal Spray is an addition to any emergency first aid kit. Use as directed.",
            "taxCode": "51010",
            "price": 1258.92,
            "shortQtyDescriptor": "cs",
            "thumbnail": CAROUSEL_IMAGES_NARCAN_CASE.NARCAN_CASE_THREE,
            "fullsizeImg": CAROUSEL_IMAGES_NARCAN_CASE.NARCAN_CASE_THREE,
            "link": "/product/narcan-case",
            "descriptionHtml": `<div>
                    <p>                      
                       NARCAN® Nasal Spray was designed to rapidly reverse the effects of a life-threatening opioid emergency. It is used to revive someone during an overdose from many prescription opioid pain medications or street drugs such as heroin and is available as an over-the-counter treatment. Use as directed.
                    </p>
                    <p>
                      <h3>Key Features:</h3>
                        <ul>
                          <li>
                              NARCAN® Nasal Spray 6-count multi-packs are sold by the case.
                              <ul>
                                <li>Each case contains 12 cartons</li>
                                <li>Each carton contains six 4 mg devices </li>
                              </ul>
                          </li>
                          <li>NARCAN® Nasal Spray is easy to use. No nasal swabs or needles</li>
                          <li>Safe to use, even if opioids are not present</li>
                          <li>Original prescription strength</li>
                          <li>Designed to rapidly reverse the effects of an opioid emergency within minutes</li>

                        </ul>
                    </p>
                    <p>
                      <h3>Recommendations for use:</h3>
                        <ul>
                          <li>Distribute in pairs to ensure two (2) doses of NARCAN® are always available.</li>
                          <li>The full directions from the Drug Facts Label are now enclosed with each device.</li>
                        </ul>
                    </p>
                </div>`,
            "galleryImages": [
              {
                original: CAROUSEL_IMAGES_NARCAN_CASE.NARCAN_CASE_THREE,
                thumbnail: CAROUSEL_IMAGES_NARCAN_CASE.NARCAN_CASE_THREE
              },
              {
                original: CAROUSEL_IMAGES_NARCAN_CASE.NARCAN_CASE_ONE,
                thumbnail: CAROUSEL_IMAGES_NARCAN_CASE.NARCAN_CASE_ONE,
              },
              {
                original: CAROUSEL_IMAGES_NARCAN_CASE.NARCAN_CASE_TWO,
                thumbnail: CAROUSEL_IMAGES_NARCAN_CASE.NARCAN_CASE_TWO
              },
              
              {
                original: CAROUSEL_IMAGES_NARCAN_CASE.NARCAN_CASE_FOUR,
                thumbnail: CAROUSEL_IMAGES_NARCAN_CASE.NARCAN_CASE_FOUR
              }
          
            ],
            "hasNarcanAddOn": false,
            "isComingSoon": false,
            "hideOnProd": false,
            "isPreorder": false,
            "minQty": 1
        },
        { 
            "id": "WALL_UNIT",
            "urlId": "wall-unit",
            "name": "NARCAN® Nasal Spray Wall Cabinet Kit",
            "shortName": "NARCAN® Nasal Spray Wall Cabinet Kit",
            "description": "Allows naloxone to be easily accessible in the event of an opioid emergency. Kit includes wall cabinet with alarm, wayfinding signage, and directions for use poster. Wall cabinet holds 2 NARCAN® Nasal Spray cartons (sold separately).",
            "taxCode": "51010",
            "price": 197,
            "shortQtyDescriptor": "ea",
            "thumbnail": IMAGES_URL.WALL_KIT_PRODUCT,
            "fullsizeImg": IMAGES_URL.WALL_KIT_PRODUCT,
            "link": "/product/wall-unit",
            "descriptionHtml": `<div>

 

              <p> 
                  Allows naloxone to be easily accessible in the event of an opioid emergency.
Kit includes wall cabinet with alarm, wayfinding signage, and directions for use poster.
Wall cabinet holds 2 NARCAN® Nasal Spray cartons (sold separately)
              </p>
               

               
              <h3>
                Key Features of the Wall Unit Kit:
              </h3>
               
               <ul>
                 <li>
                    Included in Kit:<br/>
                    1. Wall Cabinet with Alarm<br/>
                    <ul>
                      <li>Audible alarm and flashing light to sound when cabinet door has been opened. Alarm uses 9V battery – not included with purchase.</li>
                      <li>Dimensions: L 8" X W 3" x D 9" and contains 4 mounting holes for easy hanging.</li>
                      <li>Transparent Glass Window</li>
                      <li>Stainless Steel Door & Handle</li>
                    </ul>

                    2. Wayfinding Signage<br/>
                    3. Directions for Use Poster
                
                  </li> 
                  <li>
                      NARCAN® Nasal Spray Product Sold & Shipped Separately
                      
                      <ul>
                          <li>
                          NARCAN® Nasal Spray is designed to rapidly reverse the effects of a life-threatening opioid emergency. It is used to revive someone during an overdose from many prescription opioid medications, or illicit street drugs such as heroin or fentanyl, and is available as an over-the-counter treatment.
                          </li>
                      </ul>
                  </li>
                </ul>

             </div>`,
            "galleryImages": [
              {
                original: CAROUSEL_IMAGES_WALL_UNIT_NEW.CAROUSEL_IMAGES_WALL_UNIT_ONE_NEW,
                thumbnail: CAROUSEL_IMAGES_WALL_UNIT_NEW.CAROUSEL_IMAGES_WALL_UNIT_ONE_NEW
              },
              {
                original: CAROUSEL_IMAGES_WALL_UNIT_NEW.CAROUSEL_IMAGES_WALL_UNIT_TWO_NEW,
                thumbnail: CAROUSEL_IMAGES_WALL_UNIT_NEW.CAROUSEL_IMAGES_WALL_UNIT_TWO_NEW
              },
              {
                original: CAROUSEL_IMAGES_WALL_UNIT_NEW.CAROUSEL_IMAGES_WALL_UNIT_THREE_NEW,
                thumbnail: CAROUSEL_IMAGES_WALL_UNIT_NEW.CAROUSEL_IMAGES_WALL_UNIT_THREE_NEW
              }
          
            ],
            "hasNarcanAddOn": true,
            "isComingSoon": false,
            "hideOnProd": false,
            "isPreorder": false,
            "minQty": 1
        }
    ];


    export const convertSAPKeyToFrontendKey = (sapKey: string) => {
        let productFrontendKey = sapKey;
    
    //needs to be updated when new products are added, to map DB ids to ones used with Discount Code records in Firestore, and in the UI
    //"frontend" names are more descriptive and are listed in Products.ts for the purpose of mapping products for sale into the UI,
    //while "backend" names are SAP product names and thus subject to change

    //"frontend" keys are also present in Firestore when id'ing discounts

            switch (sapKey) {
                case 'NAR062702':
                  productFrontendKey = 'NARCAN'
                break;
                case 'NAR200008':
                  productFrontendKey = 'WALL_UNIT'
                break;
                case 'NAR062706':
                  productFrontendKey = 'NARCAN_CASE'
                break;
            }

      return productFrontendKey;
    }

    export const convertProductKeyToSAPKey = (frontendKey: string) => {
      let productSAPKey = frontendKey;
    
    //needs to be updated when new products are added, to map DB ids to ones used with Discount Code records in Firestore, and in the UI
    //"frontend" names are more descriptive and are listed in Products.ts for the purpose of mapping products for sale into the UI,
    //while "backend" names are SAP product names and thus subject to change

      switch (frontendKey) {
          case 'NARCAN':
              productSAPKey = 'NAR062702'
          break;
          case 'WALL_UNIT':
              productSAPKey = 'NAR200008'
          break;
          case 'NARCAN_CASE':
              productSAPKey = 'NAR062706'
          break;
      }

      return productSAPKey;
    }












